const defaultBtnClass =
  "px-2 py-1 rounded-[4px] bg-[#E6E7E8] text-[11px] font-inter-semibold text-[#808285]";
const activeBtnClass =
  "px-2 py-1 rounded-[4px] bg-white text-[11px] font-inter-semibold text-[#252526]";

const DetailTab = ({ handleMoveTo, status, countListing }) => {
  const _renderCount = (countStr, noCap = false) => {
    const count = parseInt(countStr);

    if (!count || count === "0") return "";

    if (noCap) {
      return (
        <span
          className={`h-4 px-1  font-inter text-[#808285] ${status === "interested" ? "font-inter-semibold text-[#252526]" : "bg-[#E6E7E8]"}`}
        >
          ({count})
        </span>
      );
    }
    if (count > 9 && !noCap)
      return (
        <span className="h-4 px-1 bg-[#FD4949] font-inter text-white">9+</span>
      );
    return (
      <span className="h-4 px-1 bg-[#FD4949] font-inter text-white">
        {count}
      </span>
    );
  };

  const _handleClickTab = (tab) => {
    handleMoveTo(tab);
  };

  return (
    <div className="flex items-center rounded-[4px] justify-center p-0.5 bg-[#E6E7E8] w-fit">
      <button
        onClick={() => _handleClickTab("matched")}
        className={status === "matched" ? activeBtnClass : defaultBtnClass}
      >
        Saran {_renderCount(countListing?.count_listing_matched)}
      </button>
      <button
        onClick={() => _handleClickTab("sent")}
        className={status === "sent" ? activeBtnClass : defaultBtnClass}
      >
        Terkirim {_renderCount(countListing?.count_listing_sent)}
      </button>
      <button
        onClick={() => _handleClickTab("interested")}
        className={status === "interested" ? activeBtnClass : defaultBtnClass}
      >
        Tertarik {_renderCount(countListing?.count_listing_interested, true)}
      </button>
      <button
        onClick={() => _handleClickTab("not_interested")}
        className={
          status === "not_interested" ? activeBtnClass : defaultBtnClass
        }
      >
        Tidak Tertarik
      </button>
    </div>
  );
};

export default DetailTab;
